import styles from "@/styles/Price.module.scss";
import formatPrice from "@/lib/formatPrice";

export default function FormatPriceTVOD({ price, ext }) {
  return (
    <span className={`${styles.price} ${styles.tvod}`}>
      価格：
      <span className={styles.priceNum}>{formatPrice(price)}円</span>
      （税込）
      {ext}
    </span>
  );
}
